import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PartnerCustomerListDatagrid } from "../../components";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import Form, { ButtonItem, ButtonOptions } from "devextreme-react/form";

export default function PartnerCustomerPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [tabSelectedIndex, setTabSelectedIndex] = useState(0);

  useEffect(() => {
    if (user.usertype === "CP" || user.usertype === "DIST") {
      var searchParamTabSelectedIndex = searchParams.get("tabSelectedIndex");

      if (searchParamTabSelectedIndex != null) {
        setTabSelectedIndex(searchParamTabSelectedIndex);
      }
    } else {
      navigate("/");
    }
  }, []);

  const breadcrumbItems = [
    { label: "Home", path: "/", active: false },
    { label: "Organization List", path: "/partner-customer", active: true },
  ];

  const CustomActionComponent = () => (
    <div>
      <Form>
        <ButtonItem
          marginTop={"auto"}
          marginBottom={"0px"}
          style={"margin-top: auto; margin-bottom: 0px"}
          width={"100%"}
        >
          <ButtonOptions
            width={"100%"}
            type={"default"}
            useSubmitBehavior={false}
            onClick={() => navigate("/partner-add-customer")}
          >
            <span className="dx-button-text">Create New Organization</span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
    </div>
  );

  return (
    <React.Fragment>
      <Breadcrumb
        title="Organization List"
        items={breadcrumbItems}
        actionItem={<CustomActionComponent />}
      />
      <div className={"content-block dx-card responsive-paddings"}>
        <PartnerCustomerListDatagrid />
      </div>
    </React.Fragment>
  );
}
